import { useSlateStatic } from 'slate-react';
import { dragIconHorizontal } from '../../../../../../assets/hostedassets';
import styles from './TableCell.module.scss';
import clsx from 'clsx';
import { handleRowSelect } from '../tableSelectionUtils';

function TableCell(props) {
    const editor: any = useSlateStatic();
    const textAlign = props.element?.textAlign || 'left';

    return (
        <td
            {...props.attributes}
            className={clsx(styles.TableCell, {
                [styles.TableCell_ColumnSelected]: props.element?.isColumnSelected,
                [styles.TableCell_RowSelected]: props.element?.isRowSelected,
            })}
            style={{ textAlign }}
            {...(!!props.element?.isRowSelected && { 'data-row-selector': true })}
        >
            {props.children}

            <div className={styles.DragIconContainer} onClick={(e) => handleRowSelect(e, editor, props?.element)}>
                <img src={dragIconHorizontal} alt="drag" height={'16px'} />
            </div>
        </td>
    );
}

export default TableCell;
